import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AWS from "aws-sdk";
import { SendEmailResponse } from "aws-sdk/clients/ses";

const {
  REACT_APP_AWS_ACCESS_KEY_ID,
  REACT_APP_AWS_SECRET_ACCESS_KEY,
  REACT_APP_AWS_REGION,
} = process.env;

AWS.config.update({
  accessKeyId: REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: REACT_APP_AWS_SECRET_ACCESS_KEY,
  region: REACT_APP_AWS_REGION,
});

const ses = new AWS.SES();

export interface ContactForm {
  name: string;
  phone: string;
  email: string;
  message: string;
}

export const sendEmail = createAsyncThunk<SendEmailResponse, ContactForm>(
  "contactForm/sendEmail",
  async (contactForm: ContactForm) => {
    const { name, phone, email, message } = contactForm;

    const params = {
      Destination: {
        ToAddresses: ["info@thehideawayretreat.com"],
      },
      Message: {
        Body: {
          Text: {
            Data: `
              Name: ${name}
              Phone: ${phone}
              Email: ${email}
              Message: ${message}
            `,
            Charset: "UTF-8",
          },
        },
        Subject: {
          Data: "Contact Us Form Submission",
          Charset: "UTF-8",
        },
      },
      Source: "info@the-hideaway-retreat.awsapps.com",
    };

    try {
      const result = await ses.sendEmail(params).promise();
      console.log(result);
      return result;
    } catch (error) {
      console.error(error);
      throw new Error("An error occurred while sending the email.");
    }
  },
);

interface ContactFormState {
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
}

const initialState: ContactFormState = {
  status: "idle",
  error: null,
};

const contactFormSlice = createSlice({
  name: "contactForm",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendEmail.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(sendEmail.fulfilled, (state) => {
        state.status = "succeeded";
      })
      .addCase(sendEmail.rejected, (state, action) => {
        state.status = "failed";
        state.error =
          action.error.message || "An error occurred while sending the email.";
      });
  },
});

export default contactFormSlice.reducer;
